import React from 'react'
import Cartitems from '../components/Cartitems'

const Cart = () => {
  return (<>
  <Cartitems/>
  </>)
}

export default Cart